const STORE_KEYS = {
  STORE: () => ['store'],
  STORE_ME: () => [...STORE_KEYS.STORE(), 'me'],
  STORE_PAGE_MODULES: () => [...STORE_KEYS.STORE(), 'page-modules'],
  STORE_AVAILABLE_LOOKS_LIST: () => [...STORE_KEYS.STORE(), 'available-looks'],
  STORE_AVAILABLE_LOOKS: (uid) => [...STORE_KEYS.STORE_AVAILABLE_LOOKS_LIST(), uid],
  STORE_AVAILABLE_BANNERS_LIST: () => [...STORE_KEYS.STORE(), 'available-banners'],
  STORE_AVAILABLE_BANNERS: (uid) => [...STORE_KEYS.STORE_AVAILABLE_BANNERS_LIST(), uid],
  STORE_AVAILABLE_VIDEOS_LIST: () => [...STORE_KEYS.STORE(), 'available-videos'],
  STORE_AVAILABLE_VIDEOS: (uid) => [...STORE_KEYS.STORE_AVAILABLE_VIDEOS_LIST(), uid],
  STORE_AVAILABLE_PARTICIPANTS_LIST: () => [...STORE_KEYS.STORE(), 'available-participants'],
  STORE_AVAILABLE_PARTICIPANTS: (uid) => [...STORE_KEYS.STORE_AVAILABLE_PARTICIPANTS_LIST(), uid],
  STORE_AVAILABLE_EVENTS_LIST: () => [...STORE_KEYS.STORE(), 'available-events'],
  STORE_AVAILABLE_EVENTS: (uid) => [...STORE_KEYS.STORE_AVAILABLE_EVENTS_LIST(), uid],
};

export default STORE_KEYS;
